export const FlexLayoutDirections = {
    VERTICAL: 'vertical',
    LTR: 'left2right',
    RTL: 'right2left',
};
//# sourceMappingURL=flexValues.js.map